// extracted by mini-css-extract-plugin
export default {"honeypot":"Honeypot_honeypot__9YzfA"};